const STRIPE_FEATURE_OVERRIDES_KEY = 'stripe-payments-ui-overrides-v1';

const parseStoredOverrides = (rawValue) => {
  if (!rawValue) return {};
  try {
    const parsed = JSON.parse(rawValue);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

export const readStripeFeatureOverrides = () => {
  try {
    return parseStoredOverrides(localStorage.getItem(STRIPE_FEATURE_OVERRIDES_KEY));
  } catch {
    return {};
  }
};

/** @deprecated Legacy browser-only overrides; prefer API `stripe_payments_enabled`. */
export const writeStripeFeatureOverride = (venueId, enabled) => {
  if (!venueId) return;
  const key = String(venueId);
  try {
    const current = readStripeFeatureOverrides();
    current[key] = Boolean(enabled);
    localStorage.setItem(STRIPE_FEATURE_OVERRIDES_KEY, JSON.stringify(current));
  } catch {
    // no-op when localStorage is unavailable
  }
};

/** Remove stale browser overrides so API is the source of truth. */
export const clearStripeFeatureOverrides = () => {
  try {
    localStorage.removeItem(STRIPE_FEATURE_OVERRIDES_KEY);
  } catch {
    // no-op
  }
};

/** Whether Stripe payments UI (dashboard Payments tab, booking pay flow) is enabled for a venue. */
export const isStripePaymentsUiEnabled = (venueId, venueLikeData) => {
  void venueId;
  return Boolean(venueLikeData?.stripe_payments_enabled);
};
